export const blogActionType = {
  ALL_BLOGS_REQUEST: "ALL_BLOGS_REQUEST",
  ALL_BLOGS_SUCCESS: "ALL_BLOGS_SUCCESS",
  ALL_BLOGS_FAIL: "ALL_BLOGS_FAIL",
};
